<template>
  <avatar
    :color="
      logoUrl
        ? 'transparent'
        : color || getColor($vuetify.theme.themes.light.secondarytext, 0.1)
    "
    :avatarUrl="logoUrl"
    :name="name"
    :cssClass="cssClass"
    :size="size"
    :borderColor="borderColor"
    :textColor="textColor"
    :icon="logoUrl ? '' : 'business'"
    :iconColor="textColor"
    :iconSize="iconSize"
  >
  </avatar>
</template>

<script>
export default {
  name: "TeamAvatar",
  components: {},
  props: {
    color: {
      type: String,
      default: ""
    },
    team: { type: Object },
    cssClass: {
      type: String,
      default: ""
    },
    size: {
      type: [Number, String],
      default: 20
    },
    borderColor: {
      type: String,
      default: ""
    },
    textColor: { type: String, default: "secondarytext" },
    iconSize: {
      type: [Number, String],
      default: 15
    }
  },
  computed: {
    name() {
      let team = this.team || {};
      return team.fullName || team.name;
    },
    logoUrl() {
      return (this.team || {}).logoUrl;
    }
  }
};
</script>
